module.exports = __webpack_public_path__ + "img/beta-feedback-o.a765697f.svg";